module.exports = __webpack_public_path__ + "img/status_2.e545b51b.png";